/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Load_Preset_ButtonInputs */



/**
* | output |
* | --- |
* | "Load Preset" |
*
* @param {Subtitle_Export_Load_Preset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_load_preset_button = /** @type {((inputs?: Subtitle_Export_Load_Preset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Load_Preset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Charger le préréglage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellung laden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica preimpostato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузить предустановку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargar ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットをロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregar predefinição")
	return /** @type {LocalizedString} */ ("Load Preset")
});